// This icon file is generated automatically.
var PUpCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M7.1 4.63a.12.12 0 00-.2 0L4.12 8.47c-.06.09 0 .2.1.2h.73a.5.5 0 00.4-.2L7 6.19l1.64 2.28c.1.13.25.2.4.2h.74c.1 0 .16-.11.1-.2L7.1 4.63z" } }, { "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8z" } }] }] }, "name": "p-up-circle", "theme": "outlined" };
export default PUpCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PUpCircleOutlined.js
// module id = 3704
// module chunks = 0